// reducer.tsx
//import { type } from "os";
import {
	SET,
	TOKEN,
	CURRENTROUTE,
	CLEAR,
	AppState,
	Action,
	CLIENTTABLE,
	ROLE,
	UPPERLEVEL,
	GAMECATEGORYTABLE,
	BREADCRUMBARRAY,
	SEARCHCLIENTDETAILS,
	SEARCHCLIENTUSERHIERARCHY,
	SEARCHUSERDETAILS,
	ACCOUNTTABLE,
	LANGUAGE,
	LANGUAGELIST,
	LANGUAGELISTEDIT,
	LANGUAGELISTEDITCATEGORYID,
	PROVIDERLIST,
	SUBPROVIDERLIST,
	CATEGORYLIST,
	GAMELIST,
	GAMELISTMODIFYFORMFIELDS,
	PROVIDERINSTRUCTION,
	ALLMAINPROVIDERSLIST,
	OPERATORPLAYERTABLE,
	PROVIDERVIEWDETAILS,
	PROVIDERCURRENCYDETAILS,
	UPPERLEBELACCOUNTLIST,
	UPPERLEBELCLIENLIST,
	LOWERLEBELACCOUNTLIST,
	LOWERLEBELCLIENTLIST,
	PROVIDERREPORTLIST,
	TOTALPROVIDERREPORTLIST,
	CATEGORYREPORTLIST,
	TOTALCATEGORYREPORTLIST,
	ALLGAMEUPLAODLIST,
	TOTALGAMECATEGORYREPORTLIST,
	GAMECATEGORYREPORTLIST,
	ADMINSETTING,
	PROVIDERACCOUNTS,
	GETCURRENCYCODE,
	GETWALLETBALANCE,
	GETBALANCELOG,
	GETASSIGNINACTIVEPROVIDER,
	GETCHILDCLIENTLIST,
	GETASSIGNPROVIDERLIST,
	GETASSIGNPROVIDERACCOUNTLIST,
	GETALLMASTERPLAYERLIST,
	GETPLAYERDETAILS,
	GETPLAYERLOG,
	REVENUEREPORTLIST,
	TOTALREVENUEREPORTLIST,
	WALLETREPORTLIST,
	PROVIDERACCOUNTLIST,
	CURRENTPROVIDER,
	CURRENTACCOUNT,
	GETSUBPROVIDERLSIT,
	CURRENTSUBPROVIDER,
	ASSIGNPROVIDERTABLE,
	CLIENTGAMELIST,
	PROVIDERTRANSACTIONREPORTLIST,
	DASHBOARDDATA,
	SEARCHUSERSBYUSERNAMEHIERARCHY,
	NAVIGATION
} from "./types";

export interface SetAction extends Action {
	type: typeof SET;
	payload: string;
}

export interface TokenAction extends Action {
	type: typeof TOKEN;
	payload: string | null;
}
export interface languageListEditCategoryIdAction extends Action {
	type: typeof LANGUAGELISTEDITCATEGORYID;
	payload: string;
}

export interface RoleAction extends Action {
	type: typeof ROLE;
	payload: string | null | undefined;
}
export interface UPPERLEVELACTION extends Action {
	type: typeof UPPERLEVEL;
	payload: string | null | undefined;
}

export interface LANGUAGEACTION extends Action {
	type: typeof LANGUAGE;
	payload: {
		lang: string;
		name: string | null | undefined;
		flag: string | undefined;
	};
}
export interface NAVIGATIONACTION extends Action{
	type : typeof NAVIGATION,
	payload: Array<string>
}

export interface LANGUAGELISTACTION extends Action {
	type: typeof LANGUAGELIST;
	payload: Array<{
		languageId: string;
		languageName: string;
		languageCode: string;
	}>;
}
export interface LANGUAGELISTEDITACTION extends Action {
	type: typeof LANGUAGELISTEDIT;
	payload: Array<{
		languageId: string;
		languageName: string;
		languageCode: string;
		languageValue: string;
	}>;
}
export interface CurrentRouteAction extends Action {
	type: typeof CURRENTROUTE;
	payload: string | null;
}

export interface ClearAction extends Action {
	type: typeof CLEAR;
	payload: undefined;
}

export interface ClientTableAction extends Action {
	type: typeof CLIENTTABLE;
	payload: Array<{
		serialNumber: number;
		clientName: string;
		clientCode: string;
		userName: string;
		UpperLevel: string;
		availableBalance: Array<{
			currency: string | null | undefined;
			balance: string | string | null | undefined;
		}>;
		currency: string;
		RegisteredDate: string;
	}>;
}
export interface OperatorPlayerTableAction extends Action {
	type: typeof OPERATORPLAYERTABLE;
	payload: Array<{
		playerUserId: string | null | undefined;
		playerName: string | null | undefined;
		operatorUserId: string | null | undefined;
		totalBet: string | null | undefined;
		totalWin: string | number | null | undefined;
		totalMargin: string | number | null | undefined;
		avarageRTP: string | number | null | undefined;
	}>;
}
export interface ProviderListAction extends Action {
	type: typeof PROVIDERLIST;
	payload: any;
}
export interface SUBPROVIDERLISTACTION {
	type: typeof SUBPROVIDERLIST;
	payload: Array<{
		subProviderId: string | null | undefined;
		subProviderName: string | null | undefined;
	}>;
}
export interface CATEGORYLISTACTION {
	type: typeof CATEGORYLIST;
	payload: Array<{
		categoryId: string | null | undefined;
		categoryName: string | null | undefined;
	}>;
}

export interface AccountTableAction extends Action {
	type: typeof ACCOUNTTABLE;
	payload: Array<{
		accountId: string | null | undefined;
		accountName: string | null | undefined;
		operatorAccountType: string | null | undefined;
		status: string | null | undefined;
		currency: string | null | undefined;
		credit: string | null | undefined;
	}>;
}

export interface BREADCRUMBARRAYACTION {
	type: typeof BREADCRUMBARRAY;
	payload: Array<{
		name: string | null | undefined;
		link: string | null | undefined;
		state: object | null;
	}>;
}
export interface GAMECATEGORYTABLEACTION {
	type: typeof GAMECATEGORYTABLE;
	payload: Array<{
		categoryId: string;
		serialNumber: number;
		categoryName: string;
		status: string;
	}>;
}

export interface SEARCHCLIENTDETAILSACTION {
	type: typeof SEARCHCLIENTDETAILS;
	payload: {
		client_name: string | null | undefined;
		username: string | null | undefined;
		clientCode: number | null | undefined;
		balance: Array<{ _id: string | null | undefined; total_available_balance: string | string | null | undefined }>;
		registeredDate: string | null | undefined;
	} | null;
}

export interface SEARCHUSERDETAILSACTION {
	type: typeof SEARCHUSERDETAILS;
	payload: {
		username: string | null | undefined;
		userId: string | null | undefined;
		registeredDate: string | null | undefined;
	} | null;
}

export interface SEARCHCLIENTUSERHIERARCHYACTION extends Action {
	type: typeof SEARCHCLIENTUSERHIERARCHY;
	payload: Array<{
		clientUserName: string | null | undefined;
		clientName: string | null | undefined;
		clientId: string | null | undefined;
	}>;
}

export interface GAMELISTACTION extends Action {
	type: typeof GAMELIST;
	payload: Array<{
		id: string | null | undefined;
		serialNumber: string | null | undefined;
		image: string | null | undefined;
		gameName: string | null | undefined;
		gameId: string | null | undefined;
		category: string | null | undefined;
		code: string | null | undefined;
		rtp: number | null | undefined;
		provider: string | null | undefined;
		subProvider: string | null | undefined;
		status: string | null | undefined;
	}>;
}
export interface GAMELISTMODIFYFORMFIELDSACTION extends Action {
	type: typeof GAMELISTMODIFYFORMFIELDS;
	payload: {
		game_id: string | null | undefined;
		game_code: string | null | undefined;
		rtp: number | null | undefined;
		ext_game_id: string | null | undefined;
		provider_id: string | null | undefined;
		provider_name: string | null | undefined;
		provider_module: string | null | undefined;
		provider_module_name: string | null | undefined;
		category: string | null | undefined;
		category_name: string | null | undefined;
		image: string | null | undefined;
		is_featured: boolean | null | undefined;
		is_popular: boolean | null | undefined
	} | null;
}

export interface GETALLSUBPROVIDERLISTACTION extends Action {
	type: typeof GETSUBPROVIDERLSIT;
	payload: Array<{
		id: string | null | undefined;
		serialNumber: string | null | undefined;
		betRangeAllowed: string | null | undefined;
		providerName: string | null | undefined;
		currencyInfo: string[] | null | undefined;
		supportedCurrencyType: string | null | undefined;
		category: string[] | null | undefined;
		logo: string | null | undefined;
		status: string | null | undefined;
	}>;
}

export interface ALLMAINPROVIDERLISTACTION extends Action {
	type: typeof ALLMAINPROVIDERSLIST;
	payload: Array<{
		id: string | null | undefined;
		serialNumber: string | null | undefined;
		providerId: string | null | undefined;
		providerName: string | null | undefined;
		currencyInfo: string[] | null | undefined;
		category: string[] | null | undefined;
		logo: string | null | undefined;
		status: string | null | undefined;
		subProviderCount: string | null | undefined;
		supportedCurrencyType: string | null | undefined;
	}>;
}

export interface PROVIDERACCOUNTLISTACTION extends Action {
	type: typeof PROVIDERACCOUNTLIST;
	payload: Array<{
		categoryId: string | null | undefined;
		categoryName: string[] | null | undefined;
		slNo: string | number | null | undefined;
		providerName: string | null | undefined;
		isDefault: boolean;
		providerId: string | null | undefined;
		accountId: string | null | undefined;
		accountName: string | null | undefined;
		operatorAccountType: string | null | undefined;
		status: boolean | string | null | undefined;
		currency: string[] | null | undefined;
	}>;
}

export interface ALLGAMEUPLAODLISTACTION extends Action {
	type: typeof ALLGAMEUPLAODLIST;
	payload: Array<{
		id: string | null | undefined;
		serialNumber: string | null | undefined;
		categoryId: string | null | undefined;
		providerId: string | null | undefined;
		gameName: string | null | undefined;
		gameCode: string | null | undefined;
		gameImage: string | null | undefined;
		isError: boolean | null | undefined;
		description: string | null | undefined;
		provider_name: string | null | undefined;
	}>;
}
export interface PROVIDERVIEWDETAILSTACTION extends Action {
	type: typeof PROVIDERVIEWDETAILS;
	payload: {
		_id: string;
		provider_id: string | null | undefined;
		module_id: string;
		game_provider_name: Array<{
			_id: string;
			language_name: string;
			language_code: string;
			language_value: string;
		}>;
		is_subprovider: boolean;
		game_categories: Array<{
			Category_id: string;
			Category_name: string;
		}>;
		is_betrange_allowed: string;
		betrange_info: any[];
		currency_account_type: string | null | undefined;
		currency: any[];
		logo: string;
		lobby_image: string;
		resale_price: number;
		game_category: any[];
		total_games: number;
		provider_account_technicals: any[];
		status: string;
		instruction: string | null | undefined;
	};
}
export interface PROVIDERCURRENCYDETAILSACTION extends Action {
	type: typeof PROVIDERCURRENCYDETAILS;
	payload: Array<{
		_id: string | null | undefined;
		currency_code: string | null | undefined;
		status: string | null | undefined;
	}>;
}

export interface PROVIDERINSTRUCTIONACTION extends Action {
	type: typeof PROVIDERINSTRUCTION;
	payload: string | null;
}

export interface UPPERLEBELCLIENTLISTACTION extends Action {
	type: typeof UPPERLEBELCLIENLIST;
	payload: Array<{
		upperLebelClientName: string | null | undefined;
		upperLebelClientId: string | null | undefined;
		username: string | null | undefined;
	}>;
}
export interface LOWERLEBELCLIENTLISTACTION extends Action {
	type: typeof LOWERLEBELCLIENTLIST;
	payload: Array<{
		lowerLebelClientName: string | null | undefined;
		lowerLebelClientId: string | null | undefined;
		username: string | null | undefined;
	}>;
}
export interface UPPERLEBELACCOUNTLISTACTION extends Action {
	type: typeof UPPERLEBELACCOUNTLIST;
	payload: Array<{
		upperLebelAccountName: string | null | undefined;
		upperLebelAccountId: string | null | undefined;
		currency: string | null | undefined;
	}>;
}

export interface LOWERLEBELACCOUNTLISTACTION extends Action {
	type: typeof LOWERLEBELACCOUNTLIST;
	payload: Array<{
		lowerLebelAccountName: string | null | undefined;
		lowerLebelAccountId: string | null | undefined;
		currency: string | null | undefined;
	}>;
}

export interface PROVIDERREPORTLISTACTION extends Action {
	type: typeof PROVIDERREPORTLIST;
	payload: Array<{
		serialNumber: string | null | undefined;
		avarageRTP: string | null | undefined;
		totalBet: string | null | undefined;
		totalMargin: string | null | undefined;
		totalWin: string | null | undefined;
		provider: string | null | undefined;
		subProvider: string | null | undefined;
	}>;
}

export interface SEARCHUSERSBYUSERNAMEHIERARCHYACTION extends Action {
	type: typeof SEARCHUSERSBYUSERNAMEHIERARCHY;
	payload: Array<{
		player_id: string | null | undefined;
		account_user_id: string | null | undefined;
		username: string | null | undefined;
		currency_code: string | null | undefined;
		last_login: string | null | undefined;
		status: string | null | undefined;
		account_name: string | null | undefined;
		client_name: string | null | undefined;
	}>;
}

export interface PROVIDERACCOUNTSACTION extends Action {
	type: typeof PROVIDERACCOUNTS;
	payload: Array<{
		id: string;
		accountValue: string | undefined | null;
	}>;
}
export interface TOTALPROVIDERREPORTLISTACTION extends Action {
	type: typeof TOTALPROVIDERREPORTLIST;
	payload: {
		totalBet: string | null | undefined;
		avarageRTP: string | null | undefined;
		totalMargin: string | null | undefined;
		totalWin: string | null | undefined;
	};
}

export interface TOTALCATEGORYREPORTLISTACTION extends Action {
	type: typeof TOTALCATEGORYREPORTLIST;
	payload: {
		totalBet: string | null | undefined;
		avarageRTP: string | null | undefined;
		totalMargin: string | null | undefined;
		totalWin: string | null | undefined;
	};
}

export interface TOTALREVENUEREPORTLISTACTION extends Action {
	type: typeof TOTALREVENUEREPORTLIST;
	payload: {
		totalBet: string | null | undefined;
		avarageRTP: string | null | undefined;
		totalMargin: string | null | undefined;
		totalWin: string | null | undefined;
		totalRebate: string | null | undefined;
		totalRevenueBeforeRebate: string | null | undefined;
	};
}

export interface CATEGORYREPORTLISTACTION extends Action {
	type: typeof CATEGORYREPORTLIST;
	payload: Array<{
		serialNumber: string | null | undefined;
		avarageRTP: string | null | undefined;
		totalBet: string | null | undefined;
		totalMargin: string | null | undefined;
		totalWin: string | null | undefined;
		provider: string | null | undefined;
		category: string | null | undefined;
	}>;
}

export interface REVENUEREPORTLISTACTION extends Action {
	type: typeof REVENUEREPORTLIST;
	payload: Array<{
		serialNumber: string | null | undefined;
		avarageRTP: string | null | undefined;
		totalBet: string | null | undefined;
		totalMargin: string | null | undefined;
		totalWin: string | null | undefined;
		totalRebate: string | null | undefined;
		totalRevenueBeforeRebate: string | null | undefined;
		provider: string | null | undefined;
	}>;
}

export interface WALLETREPORTLISTACTION extends Action {
	type: typeof WALLETREPORTLIST;
	payload: Array<{
		serialNumber: string | null | undefined;
		availableBalance: string | null | undefined;
		transactionAmount: string | null | undefined;
		transactionDate: string | null | undefined;
		transactionFromAccount: string | null | undefined;
		transactionFromUser: string | null | undefined;
		transactionId: string | null | undefined;
		transactionToAccount: string | null | undefined;
		transactionToUser: string | null | undefined;
		transactionType: string | null | undefined;
	}>;
}

export interface GAMECATEGORYREPORTLISTACTION extends Action {
	type: typeof GAMECATEGORYREPORTLIST;
	payload: Array<{
		serialNumber: string | null | undefined;
		gameName: string | null | undefined;
		gameCode: string | null | undefined;
		gameId: string | null | undefined;
		avarageRTP: string | null | undefined;
		totalBet: string | null | undefined;
		totalMargin: string | null | undefined;
		totalWin: string | null | undefined;
		provider: string | null | undefined;
		subProvider: string | null | undefined;
		category: string | null | undefined;
		period:string | null | undefined
	}>;
}

export interface TOTALGAMECATEGORYREPORTLISTACTION extends Action {
	type: typeof TOTALGAMECATEGORYREPORTLIST;
	payload: {
		totalBet: string | null | undefined;
		avarageRTP: string | null | undefined;
		totalMargin: string | null | undefined;
		totalWin: string | null | undefined;
	};
}

export interface GETADMINSETTINGACTION extends Action {
	type: typeof TOTALGAMECATEGORYREPORTLIST;
	payload: {
		setting: {
			id: string;
			eggResalePrice: string | number | undefined | null;
		};
		currency: Array<{
			id: string;
			currencyCode: string | undefined | null;
			status: string | undefined | null;
		}>;
	};
}
export interface GETCURRENCYCODEACTION extends Action {
	type: typeof GETCURRENCYCODE;
	payload: string | undefined | null;
}

export interface GETWALLETBALANCEACTION extends Action {
	type: typeof GETWALLETBALANCE;
	payload: string | undefined | null;
}

export interface GETBALANCELOGACTION extends Action {
	type: typeof GETBALANCELOG;
	payload: {
		balanceDetails: {
			availableBalance: string | undefined | null;
			lastUpdated: string | undefined | null;
		};
		transactionDetails: Array<{
			availableBalance: string | undefined | null;
			credit: string | undefined | null;
			date: string | undefined | null;
			debit: string | undefined | null;
			notes: string | undefined | null;
		}>;
	};
}
export interface GETASSIGNINACTIVEPROVIDERACTION extends Action {
	type: typeof GETASSIGNINACTIVEPROVIDER;
	payload: {
		clientList: Array<{
			label: string | undefined | null;
			value: string;
			username : string | undefined | null;
		}>;
		provider: Array<{
			providerId: string;
			serialNumber: number | string;
			providerName: string | undefined | null;
			isSubProvider: boolean | undefined | null;
			subProviderName: string | null;
			providerLogo: string | undefined;
			mapped : boolean
		}>;
	};
}

export interface GETCHILDCLIENTLISTACTION extends Action {
	type: typeof GETCHILDCLIENTLIST;
	payload: Array<{
		label: string | undefined | null;
		value: string;
	}>;
}

export interface GETASSIGNPROVIDERLISTACTION extends Action {
	type: typeof GETASSIGNPROVIDERLIST;
	payload: Array<{
		providerId: string | null | undefined;
		providerName: string | null | undefined;
		logo: string;
	}>;
}

export interface GETASSIGNPROVIDERACCOUNTLISTACTION extends Action {
	type: typeof GETASSIGNPROVIDERACCOUNTLIST;
	payload: Array<{
		_id: string;
		name: string | undefined | null;
		selected: { value: string; label: string } | null;
		accounts: Array<{ value: string; label: string, selected: boolean | undefined }>;
	}>;
}

export interface GETALLMASTERPLAYERLISTACTION extends Action {
	type: typeof GETALLMASTERPLAYERLIST;
	payload: Array<{
		accountId: string | undefined | null;
		externalId: string | undefined | null;
		playerId: string | undefined | null;
		status: string | undefined | null;
		userName: string | undefined | null;
		lastLogIn: string | undefined | null;
		registerDate: string | undefined | null;
		currency: string | undefined | null;
	}>;
}

export interface GETPLAYERDETAILSACTION extends Action {
	type: typeof GETPLAYERDETAILS;
	payload: {
		accountId: string;
		clientId: string;
		clientName: string;
		currency: string;
		externalPlayerId: string;
		lastLogIn: string;
		playerId: string;
		status: string;
		username: string;
	};
}

export interface GETPLAYERLOGACTION extends Action {
	type: typeof GETPLAYERLOG;
	payload: Array<{
		accountId: string;
		userId: string;
		externalUserId: string;
		transactionId: string;
		action: string;
		amount: string;
		availableBalance: string;
		gameDetails: string | {} | null;
		gameTitle: string;
		gameId: string;
		gameCategoryName: string;
		roundId: string;
		provider: string;
		dateTime: string;
	}>;
}
export interface CURRENTPROVIDERACTION extends Action {
	type: typeof CURRENTPROVIDER;
	payload: {
		_id: string;
		name: string;
	};
}

export interface CURRENTSUBPROVIDERACTION extends Action {
	type: typeof CURRENTSUBPROVIDER;
	payload: {
		_id: string;
		name: string;
	};
}
export interface CURRENTACCOUNTACTION extends Action {
	type: typeof CURRENTACCOUNT;
	payload: {
		_id: string;
		name: string;
	};
}

export interface ASSIGNPROVIDERTABLEACTION extends Action {
	type: typeof ASSIGNPROVIDERTABLE;
	payload: Array<{
		game_provider_id: string | null | undefined;
		game_provider_name: string | null | undefined;
		mapped: boolean | null | undefined
	}>
}

export interface CLIENTGAMELISTACTION extends Action {
	type: typeof CLIENTGAMELIST;
	payload: Array<{
		serialNumber: string | null | undefined;
		game_id: string | null | undefined;
		game_name: string | null | undefined;
		game_code: string | null | undefined;
		game_provider_id: string | null | undefined;
		provider_name: string | null | undefined;
		game_category_id: string | null | undefined;
		category_name: string | null | undefined;
		game_image: string | null | undefined;
		status: string | null | undefined;
		release_date: string | null | undefined;
	}>
}
const initialState: AppState = {
	sidebarShow: "responsive",
	token: null,
	currentRoute: null,
	language: {
		lang: "en",
		name: "English",
		flag: "/media/flags/united-states.svg",
	},
	languageList: [],
	languageListEdit: [],
	clientTable: [],
	accountTable: [],
	operatorPlayerTable: [],
	gameCategoryTable: [],
	role: null,
	upperLevel: null,
	breadCrumbArray: [],
	searchClientDetails: null,
	searchClientUserHierarchy: [],
	searchUserDetails: null,
	languageListEditCategoryId: null,
	providerList: [],
	providerAccountList: [],
	subProviderList: [],
	categoryList: [],
	gameList: [],
	gameListModifyFormFields: null,
	providerInstruction: null,
	allMainProvidersList: [],
	allGameUploadList: [],
	ProviderViewDetails: {
		_id: "",
		provider_id: "",
		module_id: "",
		game_provider_name: [],
		is_subprovider: false,
		game_categories: [],
		is_betrange_allowed: "",
		betrange_info: [],
		currency_account_type: "",
		currency: [],
		logo: "",
		lobby_image: "",
		resale_price: 0,
		game_category: [],
		total_games: 0,
		provider_account_technicals: [],
		status: "",
		instruction: ""
	},
	ProviderCurrencyDetails: [],
	upperLebelClientList: [],
	lowerLebelClientList: [],
	upperLebelAccountList: [],
	lowerLebelAccountList: [],
	providerReportList: [],
	walletReportList: [],
	totalProviderReportList: {
		totalBet: "",
		avarageRTP: "",
		totalMargin: "",
		totalWin: "",
	},
	totalCategoryReportList: {
		totalBet: "",
		avarageRTP: "",
		totalMargin: "",
		totalWin: "",
	},
	totalRevenueReportList: {
		totalBet: "",
		avarageRTP: "",
		totalMargin: "",
		totalWin: "",
		totalRebate: "",
		totalRevenueBeforeRebate: "",
	},
	revenueReportList: [],
	totalGameCategoryReportList: { totalBet: "", avarageRTP: "", totalMargin: "", totalWin: "" },
	categoryReportList: [],
	gameCategoryReportList: [],
	providerTransactionReportList:[],
	adminSetting: {
		setting: {
			id: "",
			eggResalePrice: 0,
		},
		currency: [],
	},
	providerAccounts: [],
	currencyCode: "KRW",
	walletBalance: "",

	balanceLog: {
		balanceDetails: {
			availableBalance: "",
			lastUpdated: "",
		},

		transactionDetails: [],
	},
	assignInActiveProvider: { clientList: [], provider: [] },
	childClientList: [],
	assignProviderList: [],
	assignProviderAccountList: [],
	allMasterPlayerList: [],

	playerDetails: {
		accountId: "",
		clientId: "",
		clientName: "",
		currency: "",
		externalPlayerId: "",
		lastLogIn: "",
		playerId: "",
		status: "",
		username: "",
	},
	playerLog: [],
	currentProvider: {
		_id: "",
		name: "",
	},
	currentAccount: {
		_id: "",
		name: "",
	},
	currentSubProvider: {
		_id: "",
		name: "",
	},
	allSubProviderList: [],

	assignedProviderTable: [],
	clientGameList: [],

	dashboardData: {
		total_month_bet: "",
		total_month_win: "",
		total_today_bet: "",
		total_today_win: "",
	},
	searchUsersByUsernameHierarchy: [],
	navigation:[]
};

const reducer = (state: AppState = initialState, action: Action): AppState => {
	switch (action.type) {
		case SET: {
			const { payload } = action as SetAction;
			return { ...state, sidebarShow: payload };
		}

		case TOKEN:
			return { ...state, token: action.payload };

		case ROLE: {
			const { payload } = action as SetAction;
			return { ...state, role: payload };
		}
		case NAVIGATION: {
			const { payload } = action as NAVIGATIONACTION;
			return { ...state, navigation: payload };
		}
		case CURRENTROUTE: {
			const { payload } = action as SetAction;
			return { ...state, token: payload };
		}

		case CLIENTTABLE: {
			const { payload } = action as ClientTableAction;
			return { ...state, clientTable: payload };
		}
		case OPERATORPLAYERTABLE: {
			const { payload } = action as OperatorPlayerTableAction;
			return { ...state, operatorPlayerTable: payload };
		}

		case ACCOUNTTABLE: {
			const { payload } = action as AccountTableAction;
			return { ...state, accountTable: payload };
		}
		case GAMECATEGORYTABLE: {
			const { payload } = action as GAMECATEGORYTABLEACTION;
			return { ...state, gameCategoryTable: payload };
		}

		case UPPERLEVEL: {
			const { payload } = action as UPPERLEVELACTION;
			return { ...state, upperLevel: payload };
		}

		case BREADCRUMBARRAY: {
			const { payload } = action as BREADCRUMBARRAYACTION;
			return { ...state, breadCrumbArray: payload };
		}

		case SEARCHCLIENTDETAILS: {
			const { payload } = action as SEARCHCLIENTDETAILSACTION;
			return { ...state, searchClientDetails: payload };
		}

		case SEARCHUSERDETAILS: {
			const { payload } = action as SEARCHUSERDETAILSACTION;
			return { ...state, searchUserDetails: payload };
		}

		case SEARCHCLIENTUSERHIERARCHY: {
			const { payload } = action as SEARCHCLIENTUSERHIERARCHYACTION;
			return { ...state, searchClientUserHierarchy: payload };
		}

		case LANGUAGE: {
			const { payload } = action as LANGUAGEACTION;
			return { ...state, language: payload };
		}

		case LANGUAGELIST: {
			const { payload } = action as LANGUAGELISTACTION;
			return { ...state, languageList: payload };
		}

		case LANGUAGELISTEDIT: {
			const { payload } = action as LANGUAGELISTEDITACTION;
			return { ...state, languageListEdit: payload };
		}

		case LANGUAGELISTEDITCATEGORYID: {
			const { payload } = action as languageListEditCategoryIdAction;
			return { ...state, languageListEditCategoryId: payload };
		}

		case PROVIDERLIST: {
			const { payload } = action as ProviderListAction;
			return { ...state, providerList: payload };
		}

		case SUBPROVIDERLIST: {
			const { payload } = action as SUBPROVIDERLISTACTION;
			return { ...state, subProviderList: payload };
		}

		case CATEGORYLIST: {
			const { payload } = action as CATEGORYLISTACTION;
			return { ...state, categoryList: payload };
		}

		case GAMELIST: {
			const { payload } = action as GAMELISTACTION;
			return { ...state, gameList: payload };
		}

		case GAMELISTMODIFYFORMFIELDS: {
			const { payload } = action as GAMELISTMODIFYFORMFIELDSACTION;
			return { ...state, gameListModifyFormFields: payload };
		}

		case PROVIDERINSTRUCTION: {
			const { payload } = action as PROVIDERINSTRUCTIONACTION;
			return { ...state, providerInstruction: payload };
		}

		case ALLMAINPROVIDERSLIST: {
			const { payload } = action as ALLMAINPROVIDERLISTACTION;
			return { ...state, allMainProvidersList: payload };
		}

		case ALLGAMEUPLAODLIST: {
			const { payload } = action as ALLGAMEUPLAODLISTACTION;
			return { ...state, allGameUploadList: payload };
		}

		case PROVIDERVIEWDETAILS: {
			const { payload } = action as PROVIDERVIEWDETAILSTACTION;
			return { ...state, ProviderViewDetails: payload };
		}

		case UPPERLEBELCLIENLIST: {
			const { payload } = action as UPPERLEBELCLIENTLISTACTION;
			return { ...state, upperLebelClientList: payload };
		}
		case LOWERLEBELCLIENTLIST: {
			const { payload } = action as LOWERLEBELCLIENTLISTACTION;
			return { ...state, lowerLebelClientList: payload };
		}
		case UPPERLEBELACCOUNTLIST: {
			const { payload } = action as UPPERLEBELACCOUNTLISTACTION;
			return { ...state, upperLebelAccountList: payload };
		}
		case LOWERLEBELACCOUNTLIST: {
			const { payload } = action as LOWERLEBELACCOUNTLISTACTION;
			return { ...state, lowerLebelAccountList: payload };
		}
		case PROVIDERREPORTLIST: {
			const { payload } = action as PROVIDERREPORTLISTACTION;
			return { ...state, providerReportList: payload };
		}
		case WALLETREPORTLIST: {
			const { payload } = action as WALLETREPORTLISTACTION;
			return { ...state, walletReportList: payload };
		}
		case PROVIDERACCOUNTS: {
			const { payload } = action as PROVIDERACCOUNTSACTION;
			return { ...state, providerAccounts: payload };
		}

		case TOTALPROVIDERREPORTLIST: {
			const { payload } = action as TOTALPROVIDERREPORTLISTACTION;
			return { ...state, totalProviderReportList: payload };
		}
		case TOTALREVENUEREPORTLIST: {
			const { payload } = action as TOTALREVENUEREPORTLISTACTION;
			return { ...state, totalRevenueReportList: payload };
		}
		case TOTALCATEGORYREPORTLIST: {
			const { payload } = action as TOTALCATEGORYREPORTLISTACTION;
			return { ...state, totalCategoryReportList: payload };
		}
		case CATEGORYREPORTLIST: {
			const { payload } = action as CATEGORYREPORTLISTACTION;
			return { ...state, categoryReportList: payload };
		}
		case REVENUEREPORTLIST: {
			const { payload } = action as REVENUEREPORTLISTACTION;
			return { ...state, revenueReportList: payload };
		}
		case GAMECATEGORYREPORTLIST: {
			const { payload } = action as GAMECATEGORYREPORTLISTACTION;
			return { ...state, gameCategoryReportList: payload };
		}

		case PROVIDERTRANSACTIONREPORTLIST: {
			//const { payload } = action as PROVIDERTR;
			return { ...state, providerTransactionReportList: action.payload };
		}

		case TOTALGAMECATEGORYREPORTLIST: {
			const { payload } = action as TOTALGAMECATEGORYREPORTLISTACTION;
			return { ...state, totalGameCategoryReportList: payload };
		}

		case ADMINSETTING: {
			const { payload } = action as GETADMINSETTINGACTION;
			return { ...state, adminSetting: payload };
		}
		case PROVIDERCURRENCYDETAILS: {
			const { payload } = action as PROVIDERCURRENCYDETAILSACTION;
			return { ...state, ProviderCurrencyDetails: payload };
		}
		case GETCURRENCYCODE: {
			const { payload } = action as GETCURRENCYCODEACTION;
			return { ...state, currencyCode: payload };
		}

		case GETWALLETBALANCE: {
			const { payload } = action as GETWALLETBALANCEACTION;
			return { ...state, walletBalance: payload };
		}

		case GETBALANCELOG: {
			const { payload } = action as GETBALANCELOGACTION;
			return { ...state, balanceLog: payload };
		}

		case GETASSIGNINACTIVEPROVIDER: {
			const { payload } = action as GETASSIGNINACTIVEPROVIDERACTION;
			let actionPayload = payload.clientList == null ? {
				provider: payload.provider,
				clientList: state.assignInActiveProvider.clientList,

			} : payload
			return { ...state, assignInActiveProvider: actionPayload };
		}

		case GETCHILDCLIENTLIST: {
			const { payload } = action as GETCHILDCLIENTLISTACTION;
			return { ...state, childClientList: payload };
		}

		case GETASSIGNPROVIDERLIST: {
			const { payload } = action as GETASSIGNPROVIDERLISTACTION;
			return { ...state, assignProviderList: payload };
		}

		case GETASSIGNPROVIDERACCOUNTLIST: {
			const { payload } = action as GETASSIGNPROVIDERACCOUNTLISTACTION;
			return { ...state, assignProviderAccountList: payload };
		}

		case GETALLMASTERPLAYERLIST: {
			const { payload } = action as GETALLMASTERPLAYERLISTACTION;
			return { ...state, allMasterPlayerList: payload };
		}

		case GETPLAYERDETAILS: {
			const { payload } = action as GETPLAYERDETAILSACTION;
			return { ...state, playerDetails: payload };
		}

		case GETPLAYERLOG: {
			const { payload } = action as GETPLAYERLOGACTION;
			return { ...state, playerLog: payload };
		}

		case PROVIDERACCOUNTLIST: {
			const { payload } = action as PROVIDERACCOUNTLISTACTION;
			return { ...state, providerAccountList: payload };
		}

		case CURRENTPROVIDER: {
			const { payload } = action as CURRENTPROVIDERACTION;
			return { ...state, currentProvider: payload };
		}

		case CURRENTACCOUNT: {
			const { payload } = action as CURRENTACCOUNTACTION;
			return { ...state, currentAccount: payload };
		}
		case CURRENTSUBPROVIDER: {
			const { payload } = action as CURRENTSUBPROVIDERACTION;
			return { ...state, currentSubProvider: payload };
		}

		case GETSUBPROVIDERLSIT: {
			const { payload } = action as GETALLSUBPROVIDERLISTACTION;
			return { ...state, allSubProviderList: payload };
		}

		case ASSIGNPROVIDERTABLE: {
			const { payload } = action as ASSIGNPROVIDERTABLEACTION;
			return { ...state, assignedProviderTable: payload }
		}

		case CLIENTGAMELIST: {
			const { payload } = action as CLIENTGAMELISTACTION;
			return { ...state, clientGameList: payload }
		}
		case CLEAR:
			return initialState;

		case DASHBOARDDATA: {
			//const { payload } = action as ASSIGNPROVIDERTABLEACTION;
			return { ...state, dashboardData: action.payload }
		}

		case SEARCHUSERSBYUSERNAMEHIERARCHY: {
			const { payload } = action as SEARCHUSERSBYUSERNAMEHIERARCHYACTION;
			return { ...state, searchUsersByUsernameHierarchy: payload };
		}
			
		default:
			return state;
	}
};

export default reducer;
